import Recipient from './Recipient';

export default Recipient;
